<template>
  <div class="paddingCustom">
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="10" md="8" class="text-center" v-html="$t('change_pwd_notification')">
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="10" sm="6" md="4">
        <v-form v-model="isFormValid">
          <v-text-field class="mt-3 mb-5" :label="$t('set_password')" color="primary-1" outlined :rules="[
            inputRules.required,
            inputRules.passwordLength,
            inputRules.password
          ]" v-model="password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'">
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
          <v-text-field class="mt-3 mb-5" :label="$t('confirm_password')" color="primary-1" outlined
            :rules="[inputRules.required, inputRules.matchPassword]" v-model="confirmPassword"
            :append-icon="showAgainPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showAgainPassword = !showAgainPassword" :type="showAgainPassword ? 'text' : 'password'"
            @input="inputField" :error-messages="passwordNotMatch ? $t('password_match_error') : ''
              ">
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
          <v-btn depressed block x-large class="nextBtn" :class="{ disabledBtn: !isFormValid || isLoading }"
            :disabled="!isFormValid || isLoading" @click="setPassword">
            <template v-if="isLoading">
              <v-progress-circular indeterminate color="white" size="25" width="2"></v-progress-circular>
            </template>
            <template v-else>
              {{ $t('next_step') }}
            </template>
          </v-btn>
        </v-form>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UM from "@/api/user-management";
import inputRulesJS from "@/shared/inputRules.js";

export default {
  data() {
    return {
      isFormValid: false,
      password: "",
      confirmPassword: "",
      showPassword: false,
      showAgainPassword: false,
      inputRules: {
        required: inputRulesJS.required,
        passwordLength: inputRulesJS.passwordLength,
        password: inputRulesJS.password,
        matchPassword: () => {
          return (
            this.confirmPassword === this.password ||
            this.$t('change_pwd_new_password_error')
          );
        }
      },
      isLoading: false,
      passwordNotMatch: false
    };
  },
  computed: {
    ...mapGetters({
      countryCode: "register/countryCode",
      mobile: "register/mobile",
      email: "register/email"
    })
  },
  mounted() {
    if (!this.mobile || !this.email) this.$router.push({ name: "Index" }).catch(() => { });
  },
  methods: {
    ...mapActions({
      storeLogin: "user/login",
      showDialog: "dialog/show"
    }),
    async setPassword() {
      if (this.confirmPassword !== this.password)
        return (this.passwordNotMatch = true);

      this.isLoading = true;
      const { data } = await UM.register(
        this.countryCode,
        this.mobile,
        this.password,
        this.email
      );
      // console.log(`${String.fromCodePoint(128049)} [UM] register`, data);
      if (data.errCode === "00") {
        // todo login
        const { data: loginRes } = await UM.login(
          this.countryCode,
          this.mobile,
          this.password
        );
        // console.log(`${String.fromCodePoint(128049)} [UM] login`, loginRes);
        if (loginRes.errCode == "00") {
          this.storeLogin({ account: this.mobile, ...loginRes.userInfo });
          this.$emit("nextStep");
        } else {
          // todo step2 register success but login fail
          this.showDialog({
            alert: true,
            content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('pwd_link_error')}</div>
          </div>`
          });
          setTimeout(() => {
            this.$router.push({ name: "Index" }).catch(() => { });
          }, 2000);
        }
      } else {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('set_pwd_register_fail')}</div>
          </div>`
        });
        console.error("註冊失敗");
      }
      this.isLoading = false;
    },
    inputField() {
      this.passwordNotMatch = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.paddingCustom {
  padding: 30px 0 60px 0;

  @media screen and (max-width: 600px) {
    padding: 0px 0 30px 0;
  }
}
</style>
